import React from "react";
import { useTranslation } from "react-i18next";
import { Controller, useFormContext } from "react-hook-form";

import FormTextarea from "@components/formGroup/formTextarea";

export default function TextAreaNote(props) {
  const { t: translate } = useTranslation([
    "pages.employés.parcours&Certifications",
    "message"
  ]);
  const { control } = useFormContext();
  const { readOnly = false, classTextarea = "arh-h-[81px]", index = 0 } = props;

  return (
    <div className="arh-mb-0">
      <Controller
        control={control}
        name={`AdvantageType.${index}.note`}
        render={({ field: { onChange, value, name } }) => (
          <FormTextarea
            placeholder={translate("Note")}
            classTextarea={classTextarea}
            label={translate("Note")}
            name={name}
            value={value}
            onChange={onChange}
            readOnly={readOnly}
          />
        )}
      />
    </div>
  );
}
